import { render, staticRenderFns } from "./SearchAliasCreateOREditDialog.vue?vue&type=template&id=f1468e50&scoped=true"
import script from "./SearchAliasCreateOREditDialog.vue?vue&type=script&lang=js"
export * from "./SearchAliasCreateOREditDialog.vue?vue&type=script&lang=js"
import style0 from "./SearchAliasCreateOREditDialog.vue?vue&type=style&index=0&id=f1468e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1468e50",
  null
  
)

export default component.exports